module.exports = __webpack_public_path__ + "static/img/matchesIcon.9f8abaf2.png";